export default "__VITE_ASSET__ff5b1b23__"